import { Header as DatagridHeader } from "@dashboard/components/Datagrid/components/Header";
import { DatagridRenderHeaderProps } from "@dashboard/components/Datagrid/Datagrid";
import useNavigator from "@dashboard/hooks/useNavigator";
import { ImportModal } from "@dashboard/imports/components/ImportModal/ImportModal";
import { ImportType } from "@dashboard/imports/types";
import { productVariantAddUrl } from "@dashboard/products/urls";
import { Button } from "@saleor/macaw-ui-next";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import messages from "../messages";
import { ManageAttributeScopeModal } from "./ManageAttributeScopeModal";

export const ProductVariantsHeader = ({
  addRowOnDatagrid,
  isAnimationOpenFinished,
  isFullscreenOpen,
  toggleFullscreen,
  productId,
  productName,
  productTypeId,
  productTypeName,
}: DatagridRenderHeaderProps & {
  productId: string;
  productName: string;
  productTypeId: string;
  productTypeName: string;
}) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const [isImportOpen, setImportOpen] = useState(false);
  const [isManageAttributesOpen, setManageAttributesOpen] = useState(false);

  const handleAddNewRow = () => {
    if (isFullscreenOpen) {
      addRowOnDatagrid();

      return;
    }

    navigate(productVariantAddUrl(productId));
  };

  const headerTitle = isAnimationOpenFinished
    ? intl.formatMessage(messages.fullScreenTitle, {
        name: productName,
      })
    : intl.formatMessage(messages.title);

  return (
    <>
      <DatagridHeader title={headerTitle}>
        <Button
          variant="secondary"
          size="small"
          onClick={() => setManageAttributesOpen(true)}
          data-test-id="manage-attributes"
        >
          <FormattedMessage
            id="Nm+bNC"
            defaultMessage="Manage attributes"
            description="manage product type attributes button"
          />
        </Button>
        <Button
          variant="secondary"
          size="small"
          onClick={() => setImportOpen(true)}
          data-test-id="import-variants"
        >
          <FormattedMessage
            id="FHhfDH"
            defaultMessage="Import Variants"
            description="import variants button"
          />
        </Button>
        <DatagridHeader.ButtonFullScreen isOpen={isFullscreenOpen} onToggle={toggleFullscreen}>
          {isFullscreenOpen ? (
            <FormattedMessage id="QjPJ78" defaultMessage="Close" description="close full-screen" />
          ) : (
            <FormattedMessage
              id="9OZ/fr"
              defaultMessage="Bulk edit"
              description="open full-screen mode with bulk edit"
            />
          )}
        </DatagridHeader.ButtonFullScreen>
        <DatagridHeader.ButtonAddRow onAddRow={handleAddNewRow}>
          <FormattedMessage defaultMessage="Add variant" id="3C3Nj5" description="button" />
        </DatagridHeader.ButtonAddRow>
      </DatagridHeader>
      <ImportModal
        open={isImportOpen}
        importType={ImportType.PRODUCT_VARIANTS}
        onClose={() => setImportOpen(false)}
      />
      {productTypeId && (
        <ManageAttributeScopeModal
          open={isManageAttributesOpen}
          onClose={() => setManageAttributesOpen(false)}
          productTypeId={productTypeId}
          productTypeName={productTypeName}
        />
      )}
    </>
  );
};
